import { filter } from 'lodash';

import {
    getCampaignMessageCompoundChannel,
} from '../modules/employer/position/campaign-details/useCampaignMessageHooks';

export const CONTACT_CHANNEL_TYPES = {
    EMAIL: 'email',
    LINKED_IN: 'linkedin',
    IN_MAIL: 'inmail',
    FACEBOOK: 'facebook',
    PHONE: 'phone',
};

export const CampaignMessageType = {
    applyOnWebsite: 'applyOnWebsite',
    rejectFollowUp: 'rejectFollowUp',
};

export const CAMPAIGN_CONTACT_CHANNEL_TYPES = [
    CONTACT_CHANNEL_TYPES.LINKED_IN,
    CONTACT_CHANNEL_TYPES.EMAIL,
    CONTACT_CHANNEL_TYPES.IN_MAIL,
    getCampaignMessageCompoundChannel({
        channel: CONTACT_CHANNEL_TYPES.EMAIL,
        type: CampaignMessageType.applyOnWebsite,
    }),
    getCampaignMessageCompoundChannel({
        channel: CONTACT_CHANNEL_TYPES.EMAIL,
        type: CampaignMessageType.rejectFollowUp,
    }),
];

// eslint-disable-next-line max-len
export const emailContactChannelTypes = filter(CAMPAIGN_CONTACT_CHANNEL_TYPES, (t) => t !== CONTACT_CHANNEL_TYPES.LINKED_IN && t !== CONTACT_CHANNEL_TYPES.IN_MAIL);

export const ContactStatuses = {
    Invalid: 'Error',
    Valid: 'Valid',
    Preferred: 'Preferred',
};
